// extracted by mini-css-extract-plugin
module.exports = {"datasheet":"dataSheet_datasheet__2OvPs","datasheetText":"dataSheet_datasheetText__3j4vY"};